import { render, staticRenderFns } from "./PantallaSurtidoCompleto.vue?vue&type=template&id=387a035a&lang=true&"
import script from "./PantallaSurtidoCompleto.vue?vue&type=script&lang=js&"
export * from "./PantallaSurtidoCompleto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports